/**
* Hero Slideshow Script
* ------------------------------------------------------------------------------
*
* @namespace - HeroSlideshow
*/

var utils = require('../../utilities/js/utils');
var Slideshow = require("../../slideshow/js/slideshow");

var selectors = {
    slideshowWrapper: '[data-slideshow-wrapper]',
};

/**
* Hero slideshow constructor
*
* @param {string} container - selector for the section container DOM element
*/
function HeroSlideshow(container) {
    container = container || 'body';
    this.$container = $(container);

    this.name = 'slideshow';
    this.namespace = '.'+this.name;

    if( !$(selectors.slideshowWrapper, this.$container).length ){

        return;
    }

    var settings = {
        dots: false
    };

    this.slideshow = new Slideshow( $(selectors.slideshowWrapper, this.$container), settings);
};

module.exports = HeroSlideshow;



//////////////////
// WEBPACK FOOTER
// ./slideshow/js/heroSlideshow.js
// module id = 138
// module chunks = 3